import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';
import { type CssColorKey } from 'config/branding/colors';
import { type CssVariable } from 'config/branding/types';

const sizes = {
    xsmall: {
        viewBox: '0 0 10 10',
        width: '10px',
        height: '10px',
        path: 'M9 3L5 7L1 3',
    },
    small: {
        viewBox: '0 0 12 12',
        width: '12px',
        height: '12px',
        path: 'M1 4L6 9L11 4',
    },
    medium: {
        viewBox: '0 0 16 16',
        width: '16px',
        height: '16px',
        path: 'M1 4L8 11L15 4',
    },
};
export type ChevronSizes = keyof typeof sizes;

// @TODO Remove Record<string, unknown> when styled is fixed and we can correctly pass css via rest.
export interface ChevronDownProps extends Record<string, unknown> {
    color?: CssVariable<CssColorKey> | 'currentColor';
    height?: string | string[];
    size?: ChevronSizes;
    width?: string | string[];
    viewBox?: string | string[];
}

export const ChevronDown = ({
    color = 'currentColor',
    size = 'small',
    height,
    width,
    viewBox,
    ...rest
}: ChevronDownProps) => {
    const selectedSize = sizes[size];
    return (
        <Svg
            width={width ?? selectedSize.width}
            height={height ?? selectedSize.height}
            viewBox={viewBox ?? selectedSize.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <Path d={selectedSize.path} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </Svg>
    );
};

export default ChevronDown;
